var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":("https://xld-project-static.oss-cn-hangzhou.aliyuncs.com/xld/theme/ming/" + _vm.path + "/" + _vm.name + "." + _vm.type),"alt":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }